import type { EventFilter, TelemetryEvent } from './types';

/** Drops error events sourced from `console.error` when `drop` is true; otherwise a no-op. */
export function dropConsoleErrors<T extends TelemetryEvent>(drop: boolean | undefined): EventFilter<T> {
  return (event) => !drop || event.type !== 'error' || event.error?.source !== 'console';
}
